import React from 'react'
import View from './view.js'
import src from './troubleshooting.mp4'

export default function Logic(props) {
  return <View {...props} src={src} />
}
